export default __webpack_public_path__ + "static/media/verssiones.5d09d319.svg";